"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Glossary = _interopRequireDefault(require("./Glossary.scss"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _ContentStore = _interopRequireDefault(require("../../../KESI2/Stores/ContentStore"));

var _FullscreenOverlay = _interopRequireDefault(require("../FullscreenOverlay/FullscreenOverlay"));

var _strings = require("./strings");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _DrupalLecture = _interopRequireDefault(require("../DrupalTiles/DrupalLecture"));

var _StoreComponent2 = _interopRequireDefault(require("../../../KESI2/Stores/StoreComponent"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var Glossary = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(Glossary, _StoreComponent);

  var _super = _createSuper(Glossary);

  function Glossary(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, Glossary);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidMount", function () {
      var glossary = _KESI2Helper["default"].getGlossary();

      _this.setState({
        content: glossary
      });
    });
    _this.state = {
      showSpinner: false,
      content: null
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Glossary.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'navbar', 'button']
    }, {
      store: _ContentStore["default"],
      keys: ['content']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(Glossary, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(_FullscreenOverlay["default"], {
        open: this.props.open,
        onClose: this.props.closeDialog,
        transition: true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Glossary["default"].toolbar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Glossary["default"].backArrow,
        onClick: function onClick() {
          _this2.props.closeDialog();
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "chevron-left"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Glossary["default"].title
      }, (0, _strings.getString)('GLOSSARY'))), this.state.content ? /*#__PURE__*/_react["default"].createElement(_DrupalLecture["default"], {
        style: {
          paddingTop: '64px'
        },
        showContent: true,
        params: {
          contentId: this.state.content.id
        },
        contentPathArray: [_config["default"].rootId],
        goUpFunc: this.props.closeDialog
      }) : null);
    }
  }]);
  return Glossary;
}(_StoreComponent2["default"]);

Glossary.propTypes = {
  open: _propTypes["default"].bool,
  closeDialog: _propTypes["default"].func,
  setTitle: _propTypes["default"].func
};
var _default = Glossary;
exports["default"] = _default;